import { render } from "./MyBrandsButton.vue.js?vue&type=template&id=0813fd38!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyBrandsButton.vue?vue&type=template&id=0813fd38"
import script from "./MyBrandsButton.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyBrandsButton.vue?vue&type=script&lang=js"
export * from "./MyBrandsButton.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyBrandsButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/MyBrandsButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0813fd38"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0813fd38', __exports__)) {
    api.reload('0813fd38', __exports__)
  }
  
  module.hot.accept("./MyBrandsButton.vue.js?vue&type=template&id=0813fd38!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MyBrandsButton.vue?vue&type=template&id=0813fd38", () => {
    api.rerender('0813fd38', render)
  })

}


export default __exports__